"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRow = exports.StyledCollapseCell = exports.StyledTableCell = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const cells_1 = require("../cells");
exports.StyledTableCell = (0, styled_components_1.default)(cells_1.IconTableCell) `
  .MuiCheckbox-root {
    padding-top: 0;
    padding-bottom: 0;

    &.MuiCheckbox-colorPrimary:hover {
      background-color: transparent;
    }
  }
`;
exports.StyledCollapseCell = (0, styled_components_1.default)(cells_1.IconTableCell) `
  .MuiButtonBase-root {
    padding: 0;
  }
  width: 5%;
`;
const rowHeightExpanded = '160px';
const rowHeightCollapsed = '41px'; // image height + table cell border
exports.StyledRow = (0, styled_components_1.default)(material_1.TableRow) `
  background-color: ${({ theme }) => theme.palette.common.white};
  height: ${rowHeightCollapsed};
  vertical-align: top;

  &.row--highlighted {
    background-color: ${ui_components_1.baseColors.primaryGreen001};
  }

  &.row--checked {
    background-color: ${ui_components_1.baseColors.primaryGreen001};
  }

  &.row--expanded {
    height: ${rowHeightExpanded};
  }

  .row-expand-cell {
    cursor: pointer;
  }
`;
